<template>
  <div class="file-icon">
    <div v-if="fileType === 'pdf'">
      <fa icon="file-pdf"></fa>
    </div>
    <div v-else-if="fileType === 'doc' || fileType === 'docx'">
      <fa icon="file-word"></fa>
    </div>
    <div v-else-if="fileType === 'xls' || fileType === 'xlsx' || fileType === 'csv' || fileType === 'xlsm'">
      <fa icon="file-excel"></fa>
    </div>
    <div v-else-if="fileType === 'png' || fileType === 'bmp' || fileType === 'jpeg' || fileType === 'jpg'">
      <fa icon="file-image"></fa>
    </div>
    <svg v-else xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" stroke="none">
      <circle cx="12" cy="12" r="10" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'file-icon',
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fileType() {
      return this.file.name.split('.').pop().toLowerCase();
    },
  },
};
</script>

<style scoped lang="scss">
.file-icon {
  /* Add any styles for the file icons here */
}
</style>